import cheader from '@/components/header/index.vue'

export default {
  name: 'inquiry',
  data() {
    return {
      serverUrl: this.$store.state.config.serverUrl,
      search: {
        name: '',
        range: 'all',
        quoted: this.$route.params.uid == 'none' ? false : true
      },
      activeName: 'all',
      datas: [],
      total: 0,
      loading:true,
      curpage: 1
    }
  },
  components: {
    cheader
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    shows: {
      get() {
        return this.datas.map((item) => {
          return item.id
        })
      },
      set() {
      }
    }
  },
  created() {
    this.index(1)
  },
  methods: {
    go(url) {
      this.$router.push(url)
    },
    gotoInfo(item){
      if(item.billType == "0"){//普通询价
        if((this.user.types == "1" || this.user.types == "5") && item.status == "1"){
          this.$router.push({
            path:"/order/"+item.id
          })
        }else if((this.user.types == "1" || this.user.types == "5") && item.status == "2"){
          this.$router.push({
            path:"/order/result/"+item.enquiryId
          })
        }
      }else{//采购单询价
         if(this.user.types == "1" && item.status == "1"){
            this.$router.push({
              path:"/order/"+item.id
            })
         }else if(this.user.types == "5" && item.finishStatus != "0"){
            this.$router.push({
              path:"/order/"+item.id
            })
         }else if(this.user.types == "1" && item.status == "2"){
            this.$router.push({
              path:"/order/result/"+item.enquiryId
            })
         }else if(this.user.types == "5" && item.finishStatus == "0"){
            this.$router.push({
              path:"/order/result/"+item.enquiryId
            })
         }
      }
       
    },
    changeStatus(item){
      if(item.nowStatus==1){
        item.nowStatus = 2
      }else{
        item.nowStatus = 1
      }
      this.$set(this.datas,"nowStatus",item)
    },

    index(page) {
      this.loading=true
      this.$http.get('/api/inquiry', {
        params: {
          userId: this.user.id,
          keywords: this.search.name,
          quoted: this.search.quoted,
          aimType: this.search.range,
          page: page,
          pageSize: 10
        }
      }).then((res) => {
        if(res.data.data!="" &&res.data.data!=undefined){
          res.data.data.forEach(function(row){
            row.nowStatus = 1
          })
        }
        this.datas = res.data.data ? res.data.data : []
        this.total = res.data.total
        this.loading = false
      })
    },
    handleChange(val) {
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/home/inquiry/index/index.js